import _ from 'lodash'

import { offlineDataUpdateCache, indexeddb, IndexedDBCache } from '@skinsoft/offline'
import { DEFAULT_PROXY } from '@skinsoft/network'
import { MediaTransferHelper } from './media-transfer-helper'

declare const REPORTER_SUBALBUM_ID: string

export class ImageTransferHelper {

    private proxy = DEFAULT_PROXY;

    public static getInstance() {
        if (!ImageTransferHelper.instance) {
            ImageTransferHelper.instance = new ImageTransferHelper();
        }

        return ImageTransferHelper.instance;
    }

    public static install(Vue) {
        Vue.prototype.$imageTransferHelper = ImageTransferHelper.getInstance();
    }

    private static instance: ImageTransferHelper = null as any;
    private cache = new IndexedDBCache();

    public replaceImageCacheKeyWithIdFromFileName(fileName: string) {
        return MediaTransferHelper.getInstance().replaceMediaCacheKeyWithIdFromFileName(fileName, this.cache)
    }

    public downloadImage(mediaId: string, fileType = "vignette250", offlineLoading = false) {
        return MediaTransferHelper.getInstance().downloadMedia(mediaId, fileType, offlineLoading, this.cache)
    }

    public downloadImageOffline(mediaId: string) {
        return MediaTransferHelper.getInstance().downloadMediaOffline(mediaId, this.cache)
    }

    public uploadImage(mimeType: string, file: File, localUrl: string, isAssociatedDocument?, isOffline?: boolean) {
        return MediaTransferHelper.getInstance().uploadMedia(mimeType, file, localUrl, this.cache, isAssociatedDocument, isOffline)
    }

    public uploadImageInCache(file: File, localUrl: string) {
        return MediaTransferHelper.getInstance().uploadMediaInCache(file, localUrl, this.cache)
    }

    public deleteImageInCache(id: string) {
        this.cache.remove(id)
    }

    public async cleanCachedImages() {
        let cachedMediakeys = await indexeddb.keys()
        cachedMediakeys = cachedMediakeys.filter(key => !key.startsWith('/translations'))
        const updateCacheKeys = await offlineDataUpdateCache.keys()
        
        // if the image have been uploaded, there is no need to keep them in cache

        const cachedEntitiesJSON = updateCacheKeys.map(async (key) => {
            const entity = await offlineDataUpdateCache.getItem(key)
            return JSON.stringify(entity)
        })

        // for the local images, we need to check that they are not used in a cached entity
        for(const key of cachedMediakeys) {
            // if the media has been added offline we have to check that it is not referenced in a cached entity
            // else we can delete it directly because it will be fetched from the api anyway
            if(MediaTransferHelper.isLocalMedia(key)) {
                let canDelete = true
                for(const cachedEntityJSON of cachedEntitiesJSON) {
                    if((await cachedEntityJSON).includes(key)) {
                        canDelete = false
                        break
                    }
                }
                if(!canDelete) {
                    continue
                }
            }
            indexeddb.removeItem(key)
        }
    }

    public addImageToReporterSubAlbum(idImage) {
        return this.addImageToAlbum(REPORTER_SUBALBUM_ID, idImage)
    }

    public addImageToAlbum(idAlbum: string, idImage: string) {
        return this.proxy.fetch(`/albums/addMedia/${idAlbum}?idMedia=${idImage}`, undefined, 'PUT')
    }
}